import { render, staticRenderFns } from "./changePasswordModal.vue?vue&type=template&id=99f1967a&scoped=true&"
import script from "./changePasswordModal.vue?vue&type=script&lang=js&"
export * from "./changePasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./changePasswordModal.vue?vue&type=style&index=0&id=99f1967a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f1967a",
  null
  
)

export default component.exports